import { ReactNode, useRef } from "react";
import { useMeeting } from "../../../hooks/meeting";
import "./ResizePanelHorizontal.css";

export type ResizePanelHorizontalProps = {
  children: ReactNode[];
};

const ResizePanelHorizontal = (props: ResizePanelHorizontalProps) => {
  const resizePanel = useRef<HTMLDivElement>(null);
  const [meeting] = useMeeting();

  // const setLeftWidth = useCallback(
  //   (newLeftWidthInPercent: number) => {
  //     setLayout((prevState) => ({
  //       ...prevState,
  //       resize: {
  //         ...prevState.resize,
  //         leftWidthInPercent: newLeftWidthInPercent,
  //       },
  //     }));
  //   },
  //   [setLayout]
  // );

  // const resize = useCallback(
  //   (event: MouseEvent) => {
  //     let totalWidthInPixels = resizePanel.current?.clientWidth;
  //     if (totalWidthInPixels) {
  //       // Make sure we are in minimum widths
  //       if (
  //         event.clientX > props.minLeftWidthInPixels &&
  //         totalWidthInPixels - event.clientX > props.minRightWidthInPixels
  //       ) {
  //         let newLeftWidth = (event.clientX / totalWidthInPixels) * 100;
  //         setLeftWidth(newLeftWidth);
  //       }
  //     }
  //   },
  //   [props.minLeftWidthInPixels, props.minRightWidthInPixels, setLeftWidth]
  // );

  // const endResize = useCallback(() => {
  //   document.body.style.cursor = "auto";
  //   window.removeEventListener("mousemove", resize);
  // }, [resize]);

  // const startResize = useCallback(
  //   (event: React.MouseEvent) => {
  //     event.stopPropagation();
  //     event.preventDefault();
  //     document.body.style.cursor = "col-resize";
  //     window.addEventListener("mousemove", resize);
  //     window.addEventListener("mouseup", endResize);
  //   },
  //   [endResize, resize]
  // );

  const children = props.children.filter((child) => !!child);
  if (!children.length) {
    return null;
  } else if (children.length < 2) {
    return (
      <div
        ref={resizePanel}
        className="ResizePanelHorizontal"
        style={{ width: "100%" }}
      >
        {children[0]}
      </div>
    );
  } else {
    return (
      <div ref={resizePanel} className="ResizePanelHorizontal">
        <div
          style={{
            width: `${100 - meeting.layout.rightSidePanelWidthInPercent}%`,
          }}
        >
          {children[0]}
        </div>
        <div className="ResizeGutter" /*onMouseDown={startResize}*/ />
        <div
          style={{
            width: `${meeting.layout.rightSidePanelWidthInPercent}%`,
          }}
        >
          {children[1]}
        </div>
      </div>
    );
  }
};

export default ResizePanelHorizontal;
